import { cn } from '../lib/cn';

/**
 * Possignin placeholder mark.
 *
 * A geometric "P" wordmark — neutral, decisive, works at all sizes.
 * Replace with the final wordmark when commissioned (per BRANDING_GUIDELINES §3).
 */
export function Logo({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        'w-7 h-7 rounded-lg grid place-items-center bg-zinc-950 dark:bg-zinc-50',
        className,
      )}
      aria-hidden="true"
    >
      <svg viewBox="0 0 24 24" className="w-4 h-4 text-white dark:text-zinc-950" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M5 4h9a5 5 0 0 1 0 10H8v6" />
      </svg>
    </span>
  );
}
